import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Log from './log-model'
import { CreateLogAsync, DeleteLogAsync, LoadLogsAsync } from './log-thunk'
const initialState: logSliceState = {
  log: [],
  selected_log: '',
  is_loading_log: false,
  is_creating_log: false,
  is_deleting_log: false,
}
export interface logSliceState {
  log: Log[]
  selected_log?: string
  is_loading_log: boolean
  is_creating_log: boolean
  is_deleting_log: boolean
}
export const logSlice = createSlice({
  name: 'log',
  initialState,
  reducers: {
    setSelectedlog: (state, action) => {
      state.selected_log = action.payload
    },
    clearStatelog: (state) => {
      state.log = []
      state.is_loading_log = false
      state.is_creating_log = false
      state.is_deleting_log = false
    },
    mergelog: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_log = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.log = merge(state.log, payload) as any
        }
      }
    },

    add_log: (state, action) => {
      if (action.payload) {
        state.log = [...state.log, action.payload]
      }
    },
    set_log: (state, action) => {
      let { key, value, id } = action.payload
      state.log = state.log.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadLogsAsync.pending, (state) => {
      state.is_loading_log = true
    })
    builder.addCase(LoadLogsAsync.fulfilled, (state, action) => {
      state.is_loading_log = false
      if (action.payload) {
        state.log = action.payload
      }
    })
    builder.addCase(LoadLogsAsync.rejected, (state) => {
      state.is_loading_log = false
    })
    builder.addCase(CreateLogAsync.pending, (state) => {
      state.is_creating_log = true
    })
    builder.addCase(CreateLogAsync.fulfilled, (state) => {
      state.is_creating_log = false
    })
    builder.addCase(CreateLogAsync.rejected, (state) => {
      state.is_creating_log = false
    })
    builder.addCase(DeleteLogAsync.pending, (state) => {
      state.is_deleting_log = true
    })
    builder.addCase(DeleteLogAsync.fulfilled, (state, action) => {
      state.is_deleting_log = false
      if (state.log) {
        state.log = state.log.filter((x) => action.payload.id !== x.id)
      }
    })
    builder.addCase(DeleteLogAsync.rejected, (state) => {
      state.is_deleting_log = false
    })
  },
})

export const { clearStatelog, setSelectedlog, set_log, mergelog, add_log } =
  logSlice.actions

export const get_log =
  (id?: string) =>
  (state: {
    log: {
      log: Log[]
    }
  }): Log | null => {
    let temp = state?.log?.log?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.log?.log[0] || null
  }
export const get_selected_log = (state: { log: logSliceState }): Log | null => {
  let id = state?.log?.selected_log
  let temp = state?.log?.log?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_log = (state: {
  log: {
    log: Log[]
  }
}): Log[] => {
  let temp = state?.log?.log
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_log_busy = (state: { log: logSliceState }) => {
  return (
    state?.log.is_deleting_log ||
    state?.log.is_loading_log ||
    state?.log.is_creating_log
  )
}
export const is_deleting_log_busy = (state: { log: logSliceState }) => {
  return state?.log.is_deleting_log
}
export const is_loading_log_busy = (state: { log: logSliceState }) => {
  return state?.log.is_loading_log
}
export const is_creating_log_busy = (state: { log: logSliceState }) => {
  return state?.log.is_creating_log
}

export default logSlice.reducer
